import { useEffect, useState } from 'react';

const matchesShape = (value: unknown, initialValue: unknown): boolean => {
  if (initialValue === undefined) return true;
  if (Array.isArray(initialValue)) return Array.isArray(value);
  if (initialValue !== null && typeof initialValue === 'object') {
    if (value === null || typeof value !== 'object' || Array.isArray(value)) return false;
    return Object.entries(initialValue).every(([key, expected]) =>
      expected === undefined || matchesShape((value as Record<string, unknown>)[key], expected)
    );
  }
  if (typeof initialValue === 'number' && Number.isInteger(initialValue) && initialValue > 0) {
    return typeof value === 'number' && Number.isInteger(value) && value > 0;
  }
  return typeof value === typeof initialValue;
};

export function useSessionState<T>(key: string, initialValue: T) {
  const [value, setValue] = useState<T>(() => {
    try {
      const saved = sessionStorage.getItem(key);
      if (saved !== null) {
        const parsed: unknown = JSON.parse(saved);
        if (matchesShape(parsed, initialValue)) return parsed as T;
      }
    } catch (error) {
      console.warn('恢复列表状态失败:', error);
    }
    return initialValue;
  });

  useEffect(() => {
    try {
      sessionStorage.setItem(key, JSON.stringify(value));
    } catch (error) {
      console.warn('保存列表状态失败:', error);
    }
  }, [key, value]);

  return [value, setValue] as const;
}
